import { LineItemTarget } from '../../../types/demandRequest'

/**
 * Formats a line item target to a display string
 * Returns 'WO-{id}' for WORK_ORDER targets, 'INV-{id}' for INVOICE targets,
 * 'ORD-{id}' for ORDER targets, and 'Stock' for items without a specific target
 * @param lineItem - Line item with targetType and targetId
 * @returns Formatted target string
 */
export const getLineItemTarget = ( lineItem: LineItemTarget ): string => {
	if ( lineItem.targetType === 'WORK_ORDER' && lineItem.targetId ) {
		return `WO-${lineItem.targetId}`
	}
	if ( lineItem.targetType === 'INVOICE' && lineItem.targetId ) {
		return `INV-${lineItem.targetId}`
	}
	if ( lineItem.targetType === 'ORDER' && lineItem.targetId ) {
		return `ORD-${lineItem.targetId}`
	}
	return 'Stock'
}
